export default __webpack_public_path__ + "static/media/skovstykket-townhouse-6-rooms-08.ee05b5c2.jpg";